/** Adds Array.prototype.toSorted() for older browsers that lack the method. */
export default function polyfill() {
    // Polyfill toSorted() for old mobile browsers
    if (!Array.prototype.toSorted) {
        Array.prototype.toSorted = function (compareFn) {
            return [...this].sort(compareFn);
        };
    }
}
